import countryList from 'static/data/country.json'
import { salutation } from 'app/constants'

export const getInitials = (str1 = '', str2 = '') => {
    if (!str1 && !str2) {
        return 'UU'
    }
    return (str1 ? str1.trim().charAt(0) : '') + (str2 ? str2.trim().charAt(0) : '')
}

export const capitalizeFirstLetter = string => {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : null
}

export const arrayPartition = (array, isValid) => {
    return array.reduce(
        ([pass, fail], elem) => {
            return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]]
        },
        [[], []]
    )
}

export const arrayDifference = (arr1, arr2) => {
    return arr1.filter(x => !arr2.includes(x))
}

export const getCountryList = () => {
    return countryList['countryCode'].map(c => {
        return { label: c.name, value: c.code }
    })
}

export const getCountryByCode = code => {
    return code ? getCountryList().find(c => c.value === code) : {}
}

export const getProfileSalutation = () => {
    return salutation.map(c => {
        return { label: c.name, value: c.code }
    })
}

export const getSalutationByCode = code => {
    return code ? getProfileSalutation().find(c => c.value === code) : {}
}

export const getExpiryTimeFromUrl = url => {
    const segments = url.split('&')
    const reg = /^exp=\d{10}/
    const index = segments.findIndex(s => reg.test(s))

    return index >= 0 ? segments[index].split('=')[1].slice(0, 10) : null
}

export const getUrlWithoutExpiry = url => {
    const segments = url.slice(1).split('&')
    const reg = /^exp=\d{10}/
    const except = segments.filter(s => !reg.test(s))

    return except.length ? `?${except.join('&')}` : ''
}

export const getRemainingTime = expTime => {
    if (!expTime) return null

    const currentTime = +new Date()
    const timeNow = currentTime.toString().slice(0, 10)
    const remainingTime = expTime - +timeNow

    return remainingTime
}

export const generateAllForPayload = ({ type, subType = 'all', fileIds, id }) => {
    const payload = {}

    if (type === 'files') {
        payload.fileIds = fileIds.join()
    } else {
        payload.allFor = {
            type,
            subType,
            id,
        }
    }
    return payload
}
export const generateAllForQuery = ({ type, subType = 'all', fileIds, id }) => {
    const query = []

    if (type === 'files') {
        query.push(`FileIds=${fileIds.join()}`)
    } else {
        query.push(`AllFor.Type=${type}`)
        query.push(`AllFor.SubType=${subType}`)
        query.push(`AllFor.Id=${id}`)
    }
    return query.join('&')
}
